export function getStripeErrorMessage(errorCode: string, rawMessage: string) {
	const errorMessages = {
		incomplete_number:
			'It looks like your card number is incomplete. Please enter the full card number.',
		incomplete_expiry: 'The expiration date is incomplete. Please enter the full expiry date.',
		incomplete_cvc: 'The security code (CVC) is incomplete. Please enter the full code.',
		invalid_number: 'The card number you entered is invalid. Please check and try again.',
		invalid_expiry_month: 'The expiration month is invalid. Please enter a valid month.',
		invalid_expiry_year: 'The expiration year is invalid. Please enter a valid year.',
		invalid_cvc: 'The CVC you entered is invalid. Please check and try again.',
		incorrect_cvc: 'The CVC code is incorrect. Please try again.',
		expired_card: 'This card has expired. Please use a different card.',
		card_declined: 'Your card was declined. Please try a different card or contact your bank.',
		processing_error:
			'There was an error processing your payment. Please try again or use a different card.',
		incorrect_number: 'The card number is incorrect. Please double-check and try again.',
		insufficient_funds:
			'There are not enough funds on this card. Please try another payment method.',
		lost_card: 'This card has been reported lost. Please use a different card.',
		stolen_card: 'This card has been reported stolen. Please use a different card.',
		authentication_required:
			'Authentication is required for this card. Please follow the instructions or try another payment method.',
		do_not_honor:
			'The card was declined by the bank. Please try another card or contact your bank.',
		reenter_transaction: 'Please re-enter your card information and try again.',
		restricted_card: 'This card cannot be used to make this payment. Please try a different card.',
		transaction_not_allowed:
			'This card does not support this type of transaction. Try another card.',
		currency_not_supported:
			'This card does not support charges in this currency. Try another payment method.',
		amount_too_large:
			'The amount is too large to be charged to this card. Try another card or reduce the amount.',
		amount_too_small:
			'The amount is too small to process. Please add more items or increase the total.',
	}

	if (errorMessages[errorCode]) {
		return errorMessages[errorCode]
	}

	// Fallback template with original message
	return `There was a problem processing your payment: "${rawMessage}". Please try again or contact support if the issue continues.`
}
